export default __webpack_public_path__ + "static/media/search-icon.6efb506b.svg";